import useQuery from '../useQuery';

/** M17 (#293, Plan 2 Slice 4): the org's per-type connection plan caps + current
 * counts (`[{ type, cap, count, can_add }]`, `cap === null` = unlimited). Drives
 * the Add-account affordance on the Channels page (R2CDd) — primary "Add" when
 * `can_add`, a locked upsell tile when at the cap. Mirrors `useIntegrationsQuery`
 * (same wrapper + gating shape). Any member can read. */
function useIntegrationLimitsQuery(sellerId, params) {
  return useQuery(`/integrations/${sellerId}/connections/limits/`, {
    enabled: Boolean(sellerId),
    staleTime: 60 * 1000,
    ...params,
  });
}

export default useIntegrationLimitsQuery;
